import { Record, OrderedSet } from 'immutable';
import { format } from 'date-fns';

export const MetricsRecord = new Record({
  name: '',
  title: '',
  value: null,
  previousValue: null,
  labelClassName: '',
});

const TestCasesClass = new Record({
  name: null,
  total_runs: null,
  avg_duration: null,
  pass_rate: null,
  last_passes: new OrderedSet(),
});

export class TestCaseRecord extends TestCasesClass {
  getDuration() {
    return format(this.avg_duration * 1000, "mm'm'ss's'");
  }

  getPassRatePercentage() {
    return `${(this.pass_rate * 100).toFixed(1)}%`;
  }
}

const TestRecordClass = new Record({
  id: null,
  consolidated_status: null,
  creation_time: null,
  duration_in_progress_sec: null,
  os_normalized: null,
  browser_normalized: null,
});

export class TestRecord extends TestRecordClass {
  formatCreationTime() {
    return format(this.creation_time, 'yyyy-MM-dd HH:MM:ss');
  }
}
